import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// One-off: purge the old service-worker cache that stored API responses, then reload once.
if ("caches" in window && "serviceWorker" in navigator) {
  caches.has("propera-v1").then(async (stale) => {
    if (!stale) return;
    await caches.delete("propera-v1");
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.update().catch(() => null)));
    if (!sessionStorage.getItem("propera_sw_purged")) {
      sessionStorage.setItem("propera_sw_purged", "1");
      window.location.reload();
    }
  }).catch(() => null);
}
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
